let headerVue;
document.addEventListener("DOMContentLoaded", function (e) {
  headerVue = Vue.createApp({
    delimiters: ["${", "}"],
    data() {
      return {
        cachedResults: {},
        predictiveSearchResults: null,
        showHeaderBar: true,
        showSearchForm: false,
        activeSubmenu: null,
        showMobileMenu: false,
        hideSiteHeader: false,
        prevScrollPos: 0,
      };
    },
    mounted() {
      const this_obj = this;
      (this.predictiveSearchResults = document.querySelector(
        "#shopify-section-predictive-search"
      )),
      this.siteHeaderHideShowBehaviour();

      //-- init AOS plugin
      AOS.init();

      //-- open cart drawer on first load
      const urlSearchParams = new URLSearchParams(window.location.search);
      const param = urlSearchParams.get("drawer");
      if (param == "true") {
        this_obj.showHeaderCart();
      }

      //-- link back mobile clicked
      const mobile_menu_wrapper = document.querySelector(
        ".mobile-menu-wrapper"
      );
      mobile_menu_wrapper.addEventListener("click", function (event) {
        if (event.target.closest("#link-back-mobile")) {
          event.preventDefault();
          this_obj.hideMobileMenuDrop(event);
        }

        return false;
      });

      //-- page overlay clicked
      const page_overlay = document.querySelector(".header-overlay");
      page_overlay.addEventListener("click", function (event) {
        if (window.innerWidth < 1024) {
          this_obj.toggleMobileMenu();
        }
        this_obj.showSearchForm = false;
      });

      //-- page overlay global clicked
      const page_overlay_global = document.querySelector(
        ".page-overlay.header-cart-overlay"
      );
      page_overlay_global.addEventListener("click", function (event) {
        this_obj.showSearchForm = false;
      });

      //-- check no-bar cookie
      if ($360.getCookie("hide_ann_bar") == "true") {
        this_obj.removeAnnBar();
      }

      //-- set menu dropdown top position
      const desktopDropdowns = document.querySelectorAll(
        "#header-con .menu-dropdown"
      );
      const mobileMenuWrapper = document.querySelector(
        "#header-con .mobile-menu-wrapper"
      );
      const headerHeight = document.querySelector(".site-header").offsetHeight;
      const headerMenuHeight = document.querySelector(
        ".site-header .header-con-outer"
      ).offsetHeight;
      if (screen.width > 1023) {
        desktopDropdowns.forEach(function (desktopDropdown) {
          if ($360.getCookie("hide_ann_bar") == "true") {
            desktopDropdown.style.top = `${headerMenuHeight - 1}px`;
          } else {
            desktopDropdown.style.top = `${headerHeight - 1}px`;
          }
        });
      }

      //-- search view all clicked
      document.addEventListener("click", function (e) {
        if (e.target.classList.contains("search-view-all")) {
          e.preventDefault();
          this_obj.clickViewAll();
        }
      });

      //-- collection filter hover behaviour
      const collection_filter = document.querySelector("#collection-filter");
      if (collection_filter != null) {
        collection_filter.classList.remove("zi-6");
        collection_filter.classList.add("zi-2");

        collection_filter.addEventListener("mouseenter", function (event) {
          event.stopPropagation();
          collection_filter.classList.add("zi-6");
          collection_filter.classList.remove("zi-2");
        });
        collection_filter.addEventListener("mouseleave", function (event) {
          event.stopPropagation();
          const filter_overlay = this.querySelector(".page-overlay");
          if (
            filter_overlay != null &&
            !filter_overlay.classList.contains("active")
          ) {
            collection_filter.classList.add("zi-2");
            collection_filter.classList.remove("zi-6");
          }
        });
      }

      //-- if URL contains #
      if (window.location.href.includes("#")) {
        const delay = setTimeout(() => {
          const scrollTop =
            document.documentElement.scrollTop || document.body.scrollTop || 0;
          const headerHeight =
            document.querySelector("#header-con").offsetHeight;

          window.scrollTo({
            top: scrollTop - headerHeight,
            behavior: "smooth",
          });

          clearTimeout(delay);
        }, 500);
      }
    },
    methods: {
      toggleCurrencySwitcher(e) {
        e.preventDefault();

        const parent = e.target.closest(".currency-selector");
        if (parent != null) {
          parent.classList.toggle("active");
        }

        return false;
      },
      changeCountry(iso_code, e) {
        e.preventDefault();
        const country_field = e.target
          .closest(".currency-selector")
          .querySelector('input[name="country_code"]');
        country_field.value = iso_code;
        country_field.closest("form").submit();

        return false;
      },
      setCookie(name, value, days) {
        let expires = "";
        if (days) {
          const date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
      },
      closeAnnBar(event) {
        event.preventDefault();

        /* set cookie expired in 2 days */
        this.setCookie("hide_ann_bar", "true", 2);
        this.removeAnnBar();
      },
      removeAnnBar() {
        const site_header = document.querySelector(".site-header");
        const ann_bar = document.querySelector(".header-bar");
        const body = document.querySelector("body");
        const global_content_tm = document.querySelector(
          ".global-content-top-margin"
        );

        if (site_header != null) {
          if (ann_bar != null) {
            ann_bar.remove();
          }

          body.classList.add("no-bar");

          $360.headerHeight =
            site_header.querySelector(".header-con-outer").offsetHeight;
          if (global_content_tm != null) {
            global_content_tm.style.marginTop = `-${ann_bar.offsetHeight}px`;
          }

          if (site_header.classList.contains("transparent")) {
            const first_section = document.querySelector(
              ".global-content-top-margin .shopify-section:first-child"
            );
            if (first_section != null) {
              first_section.style.marginTop = `-${
                $360.headerHeight + ann_bar.offsetHeight
              }px`;
            }
          }
        }
      },
      headerSearchHandler(event) {
        if (event != null) {
          event.preventDefault();
        }

        const body = document.querySelector("body");
        const filter_bar = document.querySelector("#collection-filter");
        const sticky_elem = document.querySelector(".has-sticky-elem");
        const page_overlay_global = document.querySelector(
          ".page-overlay.header-cart-overlay"
        );

        if (!body.classList.contains("no-overflow")) {
          body.classList.add("no-overflow");
          /*
                if(filter_bar != null) {
                    filter_bar.classList.remove('zi-6');
                    filter_bar.classList.add('zi-2');
                }
                */
          if (sticky_elem != null) {
            sticky_elem.classList.add("zi-2");
          }

          this.showSearchForm = !this.showSearchForm;
        } else {
          const delay = setTimeout(() => {
            /*
                    if(filter_bar != null) {
                        filter_bar.classList.remove('zi-2');
                        filter_bar.classList.add('zi-6');
                    }
                    */
            if (sticky_elem != null) {
              sticky_elem.classList.remove("zi-2");
            }
            this.showSearchForm = !this.showSearchForm;
            body.classList.remove("no-overflow");
            clearTimeout(delay);
          }, 500);
        }

        if (page_overlay_global != null) {
          //page_overlay_global.classList.toggle("active");
        }

        /* set focus to the search form */
        if (this.showSearchForm) {
          const keyword_field = document.querySelector(
            '.header-desktop-search input[id="search-term"]'
          );
          if (keyword_field != null) {
            keyword_field.focus();
          }
        }

        return false;
      },
      handleKeyDown(event) {
        if (event.key === "Enter") {
          window.location.href =
            "/search?type=product&q=" +
            document.querySelector("#search-term").value +
            "";
        }
      },
      clickViewAll() {
        window.location.href =
          "/search?type=product&q=" +
          document.querySelector("#search-term").value +
          "";
      },
      renderSearchResults(resultsMarkup) {
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        document.querySelector("#search-suggestion-links").style.display =
          "none";
        document.querySelector(
          "#shopify-section-predictive-search"
        ).style.display = "block";
      },
      destroySearchResults() {
        document.querySelector(
          "#shopify-section-predictive-search"
        ).style.display = "none";
        document.querySelector("#search-suggestion-links").style.display =
          "block";
      },
      async goSearch() {
        if (this.q.trim() == "") {
          this.destroySearchResults();
        } else {
          fetch(
            `${routes.predictive_search_url}?q=${encodeURIComponent(
              this.q
            )}&section_id=predictive-search`
          )
            .then((response) => {
              if (!response.ok) {
                var error = new Error(response.status);
                throw error;
              }

              return response.text();
            })
            .then((text) => {
              const resultsMarkup = new DOMParser()
                .parseFromString(text, "text/html")
                .querySelector("#shopify-section-predictive-search").innerHTML;

              if (resultsMarkup.includes("no-result-marker")) {
                this.destroySearchResults();
              } else {
                this.renderSearchResults(resultsMarkup);
              }
            })
            .catch((error) => {
              if (error?.code === 20) {
                // Code 20 means the call was aborted
                return;
              }
              throw error;
            });
        }

        try {
          let resultContainer = document.querySelector("#sm-search-result");
          const suggestion_elem = document.querySelector(".suggestion-wrapper");
          const req = await $360.getSearchContent("filtered", this.q);
          let { data, status } = req;

          if (this.q.trim() == "") {
            if (suggestion_elem != null) {
              suggestion_elem.classList.remove("hide-m");
            }

            resultContainer.innerHTML = "";
          } else {
            // if(suggestion_elem != null) {
            //     suggestion_elem.classList.add('hide-m');
            // }

            resultContainer.innerHTML = data;
            if (data.includes("no-result-marker")) {
              document.querySelector('.header-desktop-search').classList.add('no-result');
            } else {
              document.querySelector('.header-desktop-search').classList.remove('no-result');
            }
            setTimeout(function () {
              resultContainer
                .querySelectorAll(".product-each")
                .forEach(function (elem) {
                  let rs = elem.getAttribute("data-string");
                  if (document.querySelector(`#slider-${rs}`)) {
                    swipers[`${rs}_prefixSlider`] = new Swiper(
                      `#slider-${rs}`,
                      {
                        slidesPerView: 1,
                        loop: false,
                        a11y: false,
                        observer: true,
                        observeParents: true,
                        navigation: {
                          nextEl: `#product-card${rs} .swiper-slider-arrow.right`,
                          prevEl: `#product-card${rs} .swiper-slider-arrow.left`,
                        },
                        scrollbar: {
                          el: `#product-card${rs} .swiper-scrollbar`,
                          draggable: true,
                        },
                      }
                    );
                  }

                  if (elem.getAttribute("data-hascolor") == "true") {
                    let have_alt = false;
                    let have_var_image = false;
                    document
                      .querySelectorAll(`#product-card${rs} .swiper-slide`)
                      .forEach(function (elem) {
                        elem.classList.remove("hide-m");
                        let active_color = document
                          .querySelector(`#product-card${rs} .swatch.active`)
                          .getAttribute("data-value");
                        let this_color = elem.getAttribute("data-alt");
                        let active_image_id = document
                          .querySelector(`#product-card${rs} .swatch.active`)
                          .getAttribute("data-image-id");
                        let this_image_id = elem.getAttribute("data-id");

                        if (this_color == active_color) {
                          have_alt = true;
                        } else if (active_image_id == this_image_id) {
                          have_var_image = true;
                        }
                      });

                    if (have_alt) {
                      document
                        .querySelectorAll(`#product-card${rs} .swiper-slide`)
                        .forEach(function (elem) {
                          let active_color = document
                            .querySelector(`#product-card${rs} .swatch.active`)
                            .getAttribute("data-value");
                          let this_color = elem.getAttribute("data-alt");

                          if (this_color == active_color) {
                          } else {
                            elem.classList.add("hide-m");
                          }
                        });
                      swipers[`${rs}_prefixSlider`] = new Swiper(
                        `#slider-${rs}`,
                        {
                          slidesPerView: 1,
                          loop: false,
                          a11y: false,
                          observer: true,
                          observeParents: true,
                          navigation: {
                            nextEl: `#product-card${rs} .swiper-slider-arrow.right`,
                            prevEl: `#product-card${rs} .swiper-slider-arrow.left`,
                          },
                          scrollbar: {
                            el: `#product-card${rs} .swiper-scrollbar`,
                            draggable: true,
                          },
                        }
                      );
                    } else if (have_var_image) {
                      document
                        .querySelectorAll(`#product-card${rs} .swiper-slide`)
                        .forEach(function (elem) {
                          let active_image_id = document
                            .querySelector(`#product-card${rs} .swatch.active`)
                            .getAttribute("data-image-id");
                          let this_image_id = elem.getAttribute("data-id");

                          if (active_image_id == this_image_id) {
                          } else {
                            elem.classList.add("hide-m");
                          }
                        });
                      swipers[`${rs}_prefixSlider`] = new Swiper(
                        `#slider-${rs}`,
                        {
                          slidesPerView: 1,
                          loop: false,
                          a11y: false,
                          observer: true,
                          observeParents: true,
                          navigation: {
                            nextEl: `#product-card${rs} .swiper-slider-arrow.right`,
                            prevEl: `#product-card${rs} .swiper-slider-arrow.left`,
                          },
                          scrollbar: {
                            el: `#product-card${rs} .swiper-scrollbar`,
                            draggable: true,
                          },
                        }
                      );
                    }
                  }
                });
            }, 1000);
          }

          $360.lazyLoadInstance.update();
        } catch (error) {
          console.log(error);
        }
      },
      goSearchMobile() {
        let box = document.querySelector(".serp-mobile-box");
        let head = document.querySelector(".terms-mobile");
        let serp = document.querySelector(".serp-mobile");
        let sicon = document.querySelector(".sicon-mobile");
        let loader = document.querySelector(".sloading-mobile");
        if (this.qmobile.length > 0) {
          sicon.classList.add("shide");
          loader.classList.remove("shide");
          loader.classList.add("sshow");
          const ctn = $360.getSearchContent(
            "autosuggest",
            this.qmobile + " -tag:hidden"
          );
          // console.log('ctn', ctn);
          ctn
            .then((res) => {
              // console.log('data', res.data);
              head.innerHTML = this.qmobile;
              serp.innerHTML = res.data;
              slideDown({ element: box });
              sicon.classList.remove("shide");
              loader.classList.remove("sshow");
              loader.classList.add("shide");
            })
            .catch((err) => {
              console.error(err);
              alert(err.response.data.message);
            });
        } else {
          sicon.classList.remove("shide");
          loader.classList.remove("sshow");
          loader.classList.add("shide");
          head.innerHTML = "";
          serp.innerHTML = "";
          slideUp({ element: box });
        }
      },
      setStickyElemsToAbove() {
        const filter_bar = document.querySelector("#collection-filter");
        const sticky_elem = document.querySelector(".has-sticky-elem");

        /*
            if(filter_bar != null) {
                filter_bar.classList.remove('zi-2');
                filter_bar.classList.add('zi-6');
            }
            */
        if (sticky_elem != null) {
          sticky_elem.classList.remove("zi-2");
        }
      },
      siteHeaderHideShowBehaviour() {
        const doc = document.documentElement;
        const body = document.body;
        const headerHeight =
          document.querySelector(".site-header").offsetHeight;
        let headerBarHeight = 0;
        if (document.querySelector("#header-bar") != null) {
          headerBarHeight = document.querySelector("#header-bar").offsetHeight;
        }

        const headerMenuHeight = document.querySelector(
          ".site-header .header-con-outer"
        ).offsetHeight;
        const siteHeaderObj = document.querySelector(".site-header");
        const mobileMenuWrapper = document.querySelector(
          "#header-con .mobile-menu-wrapper"
        );
        const headerConObj = document.querySelector("#shopify-section-header");
        let announcementBar = document.querySelector("#header-bar");
        let hideHeight = 0;
        let dropdownPos = 0;
        const this_obj = this;

        window.addEventListener("scroll", () => {
          const scrollPos = Math.max(doc.scrollTop, body.scrollTop);
          const scrollDirection =
            scrollPos > this_obj.prevScrollPos ? "down" : "up";

          // Output the scroll down value to the console
          if (scrollDirection == "down" && scrollPos > headerHeight) {
            this_obj.hideSiteHeader = true;
            siteHeaderObj.classList.remove("scroll-top");
            headerConObj.classList.remove("scroll-top");
            siteHeaderObj.classList.add("scroll-down");
            headerConObj.classList.add("scroll-down");

            if (announcementBar != null) {
              hideHeight = announcementBar.offsetHeight;
            }

            headerConObj.style.top = `-${headerHeight}px`;

            //-- hide submenu
            if (
              document.querySelector(`#header-con .menu-dropdown.show`) != null
            ) {
              document
                .querySelector(`#header-con .menu-dropdown.show`)
                .classList.add("waiting-inactive");
              document
                .querySelector(`#header-con .menu-dropdown.show`)
                .classList.remove("show");

              const delay_hide = setTimeout(() => {
                document
                  .querySelector(`#header-con .menu-dropdown.waiting-inactive`)
                  .classList.remove("waiting-inactive");
                this_obj.activeSubmenu = null;

                clearTimeout(delay_hide);
              }, 50);
            }

            // adjust sticky div on PDP (desktop only)
            if (
              document.querySelector(".product-info-outer-wrapper") != null &&
              screen.width > 1023
            ) {
              const pdp_info_outer_wrapper = document.querySelector(
                ".product-info-outer-wrapper"
              );
              pdp_info_outer_wrapper.style.top = "68px";
            }

            // adjust sticky div for collection tabbed
            if (
              document.querySelector(".collection-tabbed") != null &&
              screen.width > 1023
            ) {
              const collection_tabbed_info = document.querySelector(
                ".collection-tabbed .ctc-tabs"
              );
              collection_tabbed_info.style.top = "40px";
            }

            // adjust sticky div on cart (tablet up)
            if (
              document.querySelector(".cart-right .inner.t-sticky") != null &&
              screen.width > 767
            ) {
              const sticky_elem = document.querySelector(
                ".cart-right .inner.t-sticky"
              );
              sticky_elem.style.top = "50px";
            }
            // adjust collection filter
            if (document.querySelector("#collection-filter")) {
              const collection_filter_elem =
                document.querySelector("#collection-filter");
              collection_filter_elem.style.top = "0";

              collection_filter_elem.classList.add("going-down");
              collection_filter_elem.classList.remove("going-up");
            }
          } else if (scrollDirection == "up") {
            siteHeaderObj.classList.remove("scroll-down");
            headerConObj.classList.remove("scroll-down");

            // adjust collection filter
            if (document.querySelector("#collection-filter")) {
              const collection_filter_elem =
                document.querySelector("#collection-filter");
              collection_filter_elem.style.top = `${
                headerHeight - headerBarHeight
              }px`;

              collection_filter_elem.classList.remove("going-down");
              collection_filter_elem.classList.add("going-up");

            }

            // adjust sticky div on PDP (desktop only)
            if (
              document.querySelector(".product-info-outer-wrapper") != null &&
              screen.width > 1023
            ) {
              const pdp_info_outer_wrapper = document.querySelector(
                ".product-info-outer-wrapper"
              );
              pdp_info_outer_wrapper.style.top = "80px";
            }

            // adjust sticky div for collection tabbed
            if (
              document.querySelector(".collection-tabbed") != null &&
              screen.width > 1023
            ) {
              const collection_tabbed_info = document.querySelector(
                ".collection-tabbed .ctc-tabs"
              );
              collection_tabbed_info.style.top = "150px";
            }

            // adjust sticky div on cart (tablet up)
            if (
              document.querySelector(".cart-right .inner.t-sticky") != null &&
              screen.width > 767
            ) {
              const sticky_elem = document.querySelector(
                ".cart-right .inner.t-sticky"
              );
              sticky_elem.style.top = "150px";
            }

            if (scrollPos <= headerHeight) {
              this_obj.hideSiteHeader = false;
              siteHeaderObj.classList.remove("scroll-top");
              headerConObj.classList.remove("scroll-top");

              if ($360.getCookie("hide_ann_bar") == "true") {
                dropdownPos = headerMenuHeight;
              } else {
                dropdownPos = headerHeight;
              }

              if (!body.classList.contains("no-bar")) {
                headerConObj.style.top = `0`;
              }
            } else {
              if ($360.getCookie("hide_ann_bar") == "true") {
                siteHeaderObj.style.transform = "translateY(0)";
              }

              headerConObj.style.top = `-${hideHeight}px`;
              siteHeaderObj.classList.add("scroll-top");
              headerConObj.classList.add("scroll-top");
              dropdownPos = headerMenuHeight;
            }

            // set menu dropdown top position
            const desktopDropdowns = document.querySelectorAll(
              "#header-con .menu-dropdown"
            );
            if (screen.width > 1023) {
              desktopDropdowns.forEach(function (desktopDropdown) {
                desktopDropdown.style.top = `${dropdownPos - 1}px`;
              });
            }
          }

          this_obj.prevScrollPos = scrollPos;
          this_obj.activeSubmenu = null;
        });
      },
      showHeaderCart() {
        $360.showHeaderCart();
      },
      mainNavMouseLeave(e) {
        const delay = setTimeout(() => {
          const header_links = document.querySelectorAll(
            ".header-nav .header-link"
          );
          header_links.forEach(function (header_link) {
            header_link.classList.remove("mouseover");
            header_link.classList.remove("this-hovered");
          });

          clearTimeout(delay);
        }, 30);
      },
      showDropdown(num, e) {
        const this_obj = this;
        const filter_bar = document.querySelector("#collection-filter");
        const sticky_elem = document.querySelector(".has-sticky-elem");

        if (!e.target.closest(".parent").classList.contains("with-children")) {
          if (
            document.querySelector(
              `#header-con .menu-dropdown.waiting-inactive`
            ) != null
          ) {
            document
              .querySelector(`#header-con .menu-dropdown.waiting-inactive`)
              .classList.remove("waiting-inactive");

            this_obj.activeSubmenu = null;
          }

          const delay_check = setTimeout(() => {
            if (
              document.querySelector(`#header-con .menu-dropdown.show`) != null
            ) {
              document
                .querySelector(`#header-con .menu-dropdown.show`)
                .classList.add("waiting-inactive");
              document
                .querySelector(`#header-con .menu-dropdown.show`)
                .classList.remove("show");
              document
                .querySelector(".site-header")
                .classList.remove("menu-dropdown-show");

              const delay_hide = setTimeout(() => {
                document
                  .querySelector(`#header-con .menu-dropdown.waiting-inactive`)
                  .classList.remove("waiting-inactive");
                this_obj.activeSubmenu = null;

                /*
                            if(filter_bar != null) {
                                filter_bar.classList.remove('zi-2');
                                filter_bar.classList.add('zi-6');
                            }
                            */
                if (sticky_elem != null) {
                  sticky_elem.classList.remove("zi-2");
                }

                clearTimeout(delay_hide);
              }, 50);
            }

            clearTimeout(delay_check);
          }, 100);
        } else {
          if (
            document.querySelector(`#header-con .menu-dropdown.show`) != null
          ) {
            if (num != this.activeSubmenu) {
              document
                .querySelector(`#header-con .menu-dropdown.show`)
                .classList.add("waiting-inactive");

              if (document.getElementById(`menu-dropdown-${num}`)) {
                /*
                            if(filter_bar != null) {
                                filter_bar.classList.remove('zi-6');
                                filter_bar.classList.add('zi-2');
                            }
                            */
                if (sticky_elem != null) {
                  sticky_elem.classList.add("zi-2");
                }

                document
                  .getElementById(`menu-dropdown-${num}`)
                  .classList.add("show");
                document
                  .querySelector(".site-header")
                  .classList.add("menu-dropdown-show");
              }

              const delay_hide = setTimeout(() => {
                document
                  .querySelector(`#header-con .menu-dropdown.waiting-inactive`)
                  .classList.remove("waiting-inactive");
                this_obj.activeSubmenu = num;

                clearTimeout(delay_hide);
              }, 50);
            }
          } else {
            /*
                    if(filter_bar != null) {
                        filter_bar.classList.remove('zi-6');
                        filter_bar.classList.add('zi-2');
                    }
                    */
            if (sticky_elem != null) {
              sticky_elem.classList.add("zi-2");
            }

            document
              .querySelector(".site-header")
              .classList.add("menu-dropdown-show");
            this.activeSubmenu = num;
            $360.lazyLoadInstance.update();
          }
        }

        const delay = setTimeout(() => {
          const this_link = e.target.closest(".parent");
          const header_links = document.querySelectorAll(
            ".header-nav .header-link"
          );
          header_links.forEach(function (header_link) {
            header_link.classList.add("mouseover");
            header_link.classList.remove("this-hovered");
            if (header_link.closest(".parent") == this_link) {
              header_link.classList.remove("mouseover");
              header_link.classList.add("this-hovered");
            }
          });

          clearTimeout(delay);
        }, 30);
      },
      mobileMenuAccordion(e) {
        if (window.innerWidth < 1024) {
          $360.accordionToggle(e);
        }
      },
      toggleMobileMenu(e) {
        if (e != null) {
          e.preventDefault();
        }

        //adjust height due to announcement bar
        const menu_wrapper = document.querySelector(".mobile-menu-wrapper");
        const header_con = document.querySelector("#site-header");

        if (header_con.classList.contains("scroll-top")) {
          menu_wrapper.style.height = "calc(100% - 47.9px)";
          //menu_wrapper.style.top = "48px";
        } else {
          menu_wrapper.style.height = "calc(100% - 73.9px)";
          //menu_wrapper.style.top = "80.8px";
        }
        //adjust bg color
        header_con.classList.toggle("menu-dropdown-show");

        this.showMobileMenu = !this.showMobileMenu;
        const iconMenu = document.querySelector(
          ".header-mobile-menu .icon-menu"
        );
        const iconCloseMenu = document.querySelector(
          ".header-mobile-menu .icon-close-menu"
        );
        const body = document.querySelector("body");
        const page_overlay = document.querySelector(".header-overlay");
        const filter_bar = document.querySelector("#collection-filter");
        const sticky_elem = document.querySelector(".has-sticky-elem");

        if (this.showMobileMenu) {
          /*
                if(filter_bar != null) {
                    filter_bar.classList.remove('zi-6');
                    filter_bar.classList.add('zi-2');
                }
                */
          if (sticky_elem != null) {
            sticky_elem.classList.add("zi-2");
          }

          iconMenu.classList.remove("flex");
          iconMenu.classList.add("hide-m");
          iconCloseMenu.classList.remove("hide-m");
          iconCloseMenu.classList.add("flex");
          body.classList.add("nooverflow");
          page_overlay.classList.add("show-mobile");

          let delay = setTimeout(() => {
            page_overlay.classList.add("show-fade");
            $360.lazyLoadInstance.update();

            clearTimeout(delay);
          }, 50);
        } else {
          iconMenu.classList.remove("hide-m");
          iconMenu.classList.add("flex");
          iconCloseMenu.classList.remove("flex");
          iconCloseMenu.classList.add("hide-m");
          body.classList.remove("nooverflow");
          page_overlay.classList.remove("show-fade");

          let delay = setTimeout(() => {
            page_overlay.classList.remove("show-mobile");
            /*
                    if(filter_bar != null) {
                        filter_bar.classList.remove('zi-2');
                        filter_bar.classList.add('zi-6');
                    }
                    */
            if (sticky_elem != null) {
              sticky_elem.classList.remove("zi-2");
            }

            clearTimeout(delay);
          }, 500);
        }

        return false;
      },
      toggleMobileMenuDrop(e, title) {
        const menu_wrapper = document.querySelector(".mobile-menu-wrapper");
        const header_con = document.querySelector("#site-header");

        if (header_con.classList.contains("scroll-top")) {
          menu_wrapper.style.height = "calc(100% - 47.9px)";
          //menu_wrapper.style.top = "48px";
        } else {
          menu_wrapper.style.height = "calc(100% - 73.9px)";
          //menu_wrapper.style.top = "80.8px";
        }

        const menu_dropdown_wrapper = document.querySelector(
          ".menu-dropdown-mobile-wrapper"
        );
        if (menu_dropdown_wrapper != null) {
          menu_dropdown_wrapper.classList.toggle("active");
        }

        let el = e.target.classList.contains("main-menu-title")
          ? e.target
          : e.target.closest(".main-menu-title");

        if (el) {
          if (el.closest("li").classList.contains("with-children")) {
            if (!el.closest(".parent").classList.contains("active")) {
              const active_menu = document.querySelector(
                ".mobile-menu .parent.active"
              );
              if (active_menu != null) {
                active_menu.classList.remove("active");
              }
              el.closest(".parent").classList.add("active");

              const active_dropdown = document.querySelector(
                `.menu-dropdown-mobile-wrapper .mobile-menu-dropdown:not(.hide-m)`
              );
              if (active_dropdown != null) {
                active_dropdown.classList.add("hide-m");
              }

              const current_active_dropdown = document.querySelector(
                `.menu-dropdown-mobile-wrapper .mobile-menu-dropdown[data-title="${title}"]`
              );
              if (current_active_dropdown != null) {
                current_active_dropdown.classList.remove("hide-m");
              }
            }
          } else {
            window.location.href = el.getAttribute("href");
          }
        }
      },
      hideMobileMenuDrop(e) {
        const parent = e.target.closest(".parent");
        const dropdown_el = parent.querySelector(".mobile-menu-dropdown");
        const mobile_menu_wrapper = e.target.closest(".mobile-menu-wrapper");
        mobile_menu_wrapper.classList.remove("nooverflow");

        if (parent.classList.contains("submenu-open")) {
          dropdown_el.classList.remove("show");

          const delay = setTimeout(() => {
            dropdown_el.classList.add("hide-m");
            parent.classList.remove("submenu-open");

            clearTimeout(delay);
          }, 300);
        }
      },
    },
  });
  headerVue.mount("#header-con");
});

// script-custom.js
// header cart
function initSwiperYmal() {
  setTimeout(function () {
    let carouselYmal = new Swiper(".ymal-swiper", {
      slidesPerView: 1.5,
      spaceBetween: 15,
      breakpoints: {
        1366: {
          slidesPerView: 2,
          freeMode: false,
        },
      },
      loop: false,
      a11y: false,
      on: {
        init: function () {
          $360.lazyLoadInstance.update();
        },
        slideChange: function () {
          $360.lazyLoadInstance.update();
        },
        resize: function () {
          $360.lazyLoadInstance.update();
        },
      },
    });
  }, 1000);
}
async function giftProductToggle(varId, e) {
  e.preventDefault();

  let checkbox = e.target;
  let parent = checkbox.closest(".hcb-gifting");
  let msg = parent.querySelector("#gift-msg");
  let args = {
    variantId: varId,
    qty: 1,
    properties: {
      "Gift Message": msg.value,
      _isGiftWrap: true,
    },
  };

  const btnLoading = '<span class="btn-loading"></span>';
  checkbox.style.height = `${checkbox.offsetHeight}px`;
  checkbox.style.width = `${checkbox.offsetWidth}px`;
  checkbox.innerHTML = btnLoading;

  $360.addToCart(args, function () {
    $360.refreshCartPage();
  });
}
async function checkCart() {
  let cart = await axios.get(window.Shopify.routes.root + "cart.js");
  if (cart.status == 200 && cart.data && cart.data.items.length == 1) {
    let giftWrap = cart.data.items.findIndex(
      (item) => item.properties["Gift Message"]
    );
    if (giftWrap > -1) {
      let args = {
        index: giftWrap + 1,
        qty: 0,
      };
      $360.updateItemQty(
        { index: giftWrap + 1, qty: 0, groupId: null, removeSameGroup: null },
        function () {
          $360.showHeaderCart({ update: true });
          $360.refreshCartPage();
          const removeIteminCart = new CustomEvent("RemovedItemInCartShopify", {
            detail: { items: [] },
          });
          document.dispatchEvent(removeIteminCart);
        }
      );
    }
  }
}
let giftTitle = document.querySelector(".hcb-gifting .accordion-title");
if (giftTitle != null) {
  giftTitle.addEventListener("click", function () {
    $360.adjustCartHeight();
  });
}
function changePageCartDrawer(e) {
  changeCloseButton();
  let el = e.target;
  if (!el.classList.contains("cp-btn")) {
    el = el.closest(".cp-btn");
  }
  let target = el.getAttribute("data-target");
  if (target) {
    let hcmPage = document.querySelectorAll(".hcm-page");
    let targetPage = document.querySelector(".hcm-page." + target);
    let checkoutBtn = document.querySelector("#header-cart .checkout-btn");
    let nextBtn = document.querySelector("#header-cart .next-btn");
    let backBtn = document.querySelector(".header-cart-top .back-btn");
    let backIcon = backBtn.querySelector(".icon-back");
    let orderNotes = document.querySelector(".hcb-order-notes");
    hcmPage.forEach((i) => {
      i.classList.remove("active");
    });
    targetPage.classList.add("active");
    if (target == "zapiet-portion") {
      orderNotes.classList.add("active");
      checkoutBtn.classList.add("show");
      nextBtn.classList.remove("show");
      backIcon.classList.remove("hide-m");
      backBtn.setAttribute("data-target", "cart-portion");
    } else {
      orderNotes.classList.remove("active");
      checkoutBtn.classList.remove("show");
      nextBtn.classList.add("show");
      backIcon.classList.add("hide-m");
      backBtn.setAttribute("data-target", false);
    }
  }
  setDeliveryNotes();
}
function changeCloseButton() {
  let closes = document.querySelectorAll(".Zapiet-Modal__Close-Button");
  closes.forEach((i) => {
    i.innerHTML = "";
  });
}
let zapietOpt = document.querySelectorAll(
  "#storePickupApp .checkoutMethodsContainer.default .checkoutMethod"
);
zapietOpt.forEach((i) => {
  i.addEventListener("click", changeCloseButton);
  i.addEventListener("click", function () {
    setTimeout(function () {
      setDeliveryNotes();
    }, 2000);
  });
});
changeCloseButton();
function setDeliveryNotes() {
  let formHeaderCart = document.querySelector("form#header-cart");
  let checkoutBtn = document.querySelector(".checkout-btn");
  let deliveryNotes = document.querySelector("#order-notes");
  let dnValue;
  if (deliveryNotes) {
    dnValue = deliveryNotes.value;
  }
  if (formHeaderCart) {
    let formAction = formHeaderCart.getAttribute("action");
    if (formAction.includes("note=")) {
      formAction = formAction.replace(/(&|\?)?note=[^&]*/g, "");
    }
    formAction = formAction + "&note=" + dnValue;
    formHeaderCart.setAttribute("action", formAction);
  }
  if (checkoutBtn) {
    let cbhref = checkoutBtn.getAttribute("href");
    cbhref = "/checkout?note=" + dnValue;
    checkoutBtn.setAttribute("href", cbhref);
  }
}
